import { render, staticRenderFns } from "./ContractValues.vue?vue&type=template&id=4b8c27ce&scoped=true"
import script from "./ContractValues.vue?vue&type=script&lang=js"
export * from "./ContractValues.vue?vue&type=script&lang=js"
import style0 from "./ContractValues.vue?vue&type=style&index=0&id=4b8c27ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c27ce",
  null
  
)

export default component.exports